import {
    Button,
    Chip,
    Container,
    Grid,
    Icon,
    Stack,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AccountSubscriptionType } from "../../../api/psc";
import { RootState } from "../../../slices/Store";
import { setViewInSubscriptionMode } from "../../projects/slice/ProjectSlice";

export default function Subscriptions() {
    const dispatch = useDispatch();

    const navigate = useNavigate();
    function handleNavigateToSubscription(type: AccountSubscriptionType[]) {
        dispatch(setViewInSubscriptionMode(type));
        navigate("/");
    }

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    const shared = useSelector((state: RootState) => state.shared);
    const accountSubscriptionType = shared.accountDetail.subscriptionType;

    return (
        <Container maxWidth="xl">
            <Grid
                container
                spacing={2}
                sx={{ pt: 2 }}
            >
                <Grid
                    item
                    xs={12}
                    md={6}
                    lg={4}
                >
                    <Stack
                        direction="column"
                        alignItems="center"
                        spacing={4}
                        sx={{
                            width: "100%",
                            height: "100%",
                            border: "1px solid",
                            borderColor: "divider",
                            backgroundColor: "background.paper",
                            p: 4,
                            borderRadius: "12px",
                        }}
                    >
                        <img
                            alt="taban"
                            width={75}
                            height={75}
                            src="images/subscriptions/bonyan.png"
                        />
                        <Stack
                            direction="row"
                            justifyContent="center"
                            gap={2}
                            sx={{
                                bgcolor: "#424EBC",
                                py: 1,
                                borderRadius: "12px",
                                minWidth: "200px",
                                textAlign: "center",
                            }}
                        >
                            <Typography
                                sx={{ fontSize: "20px" }}
                                color="white"
                            >
                                بنیان
                            </Typography>
                            {accountSubscriptionType ===
                                AccountSubscriptionType.STANDARD && (
                                <Chip
                                    color="secondary"
                                    label="اشتراک شما"
                                />
                            )}
                        </Stack>

                        <Stack
                            direction="row"
                            gap={1}
                            alignItems="center"
                        >
                            <Typography color="primary">
                                تعداد تقریبی پروژه‌‌ها:
                            </Typography>
                            <Chip
                                size="small"
                                color="primary"
                                label={"۱۰,۰۰۰ پروژه"}
                            ></Chip>
                        </Stack>

                        <Stack
                            direction="row"
                            gap={1}
                            alignItems="center"
                        >
                            <Typography color="primary">
                                پروژه‌های خاص این اشتراک:
                            </Typography>
                            <Chip
                                size="small"
                                color="warning"
                                label={"ندارد"}
                            ></Chip>
                        </Stack>

                        <Typography color="secondary">
                            ارزان‌تر اما هم‌چنان کارا
                        </Typography>

                        <Typography
                            color="text.secondary"
                            sx={{ minHeight: "190px" }}
                        >
                            «بنیان»، پایه و اساس هرکاری است و این اشتراک اساس
                            کار برای حضور و فروش بیشتر شما در بازار است. مانند
                            پِی و فونداسیون ساختمان که سنگ‌بنا و ضامن استحکام
                            بناست. هرچند در این اشتراک، به پروژه‌های کمتری
                            دسترسی دارید، اما کیفیت و تعهد ما به شما محکم و مثل
                            همیشه پابرجاست. پنل تبلیغات پیامک، CRM متصل به بانک
                            اطلاعات، کارگاه‌های آموزشی مارکتینگ و فروش و دیگر
                            خدمات ما در این اشتراک سرجای خودشان هستند. اگر تازه
                            می‌خواهید وارد بازار شوید و بودجه‌ی محدودی دارید،
                            این اشتراک برای شما مناسب است. با این اشتراک،
                            تجربه‌ای حرفه‌ای از فروش بسازید.
                        </Typography>

                        <Stack gap={2}>
                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    متراژ زمین: تا ۴۰۰ متر
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    کاربری: مسکونی و مسکونی تجاری
                                </Typography>
                            </Stack>
                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    زمان دسترسی به پروژه‌ها: ۱۰ روز پس از
                                    گردآوری و به‌روزرسانی
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    بازدید روزانه‌ی پروژه‌ها: ۵۰ پروژه
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    پروژه‌های درخواست خرید از سوی سازنده: ندارد
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="error">close</Icon>
                                <Typography color="text.secondary">
                                    شهرهای حومه: ندارد
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    پنل تبلیغات و پیامک: بدون شارژ اولیه (شارژ
                                    باید جداگانه خریداری شود)
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="error">close</Icon>
                                <Typography color="text.secondary">
                                    سرشماره‌ی خدماتی برای پنل پیامک: ندارد
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    سازه‌افزار (تبلیغ در وب‌سایت تبلیغاتی صنعت
                                    ساختمان در صفحه‌ی یک گوگل): دارد
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    سی-آر-ام (فرآیندهای فروش): دارد
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    کارگاه‌های آموزشی: ۲ بار (کارگاه/نفر) به مدت
                                    ۱۶ ساعت{" "}
                                </Typography>
                            </Stack>
                        </Stack>

                        <span style={{ flex: 1 }}></span>

                        <Button
                            fullWidth={true}
                            variant="contained"
                            onClick={() =>
                                handleNavigateToSubscription([
                                    AccountSubscriptionType.STANDARD,
                                ])
                            }
                        >
                            مشاهده پروژه های این نوع اشتراک
                        </Button>
                    </Stack>
                </Grid>

                <Grid
                    item
                    xs={12}
                    md={6}
                    lg={4}
                >
                    <Stack
                        direction="column"
                        alignItems="center"
                        spacing={4}
                        sx={{
                            width: "100%",
                            height: "100%",
                            border: "1px solid",
                            borderColor: "divider",
                            backgroundColor: "background.paper",
                            p: 4,
                            borderRadius: "12px",
                        }}
                    >
                        <img
                            alt="taban"
                            width={75}
                            height={75}
                            src="images/subscriptions/royan.png"
                        />
                        <Stack
                            direction="row"
                            justifyContent="center"
                            gap={2}
                            sx={{
                                bgcolor: "#424EBC",
                                py: 1,
                                borderRadius: "12px",
                                width: "200px",
                                textAlign: "center",
                            }}
                        >
                            <Typography
                                sx={{ fontSize: "20px" }}
                                color="white"
                            >
                                رویان
                            </Typography>

                            {accountSubscriptionType ===
                                AccountSubscriptionType.ENHANCED && (
                                <Chip
                                    color="secondary"
                                    label="اشتراک شما"
                                />
                            )}
                        </Stack>

                        <Stack
                            direction="row"
                            gap={1}
                            alignItems="center"
                        >
                            <Typography color="primary">
                                تعداد تقریبی پروژه‌‌ها:
                            </Typography>
                            <Chip
                                size="small"
                                color="primary"
                                label={"۱۴,۰۰۰ پروژه"}
                            ></Chip>
                        </Stack>

                        <Stack
                            direction="row"
                            gap={1}
                            alignItems="center"
                        >
                            <Typography color="primary">
                                پروژه‌های خاص این اشتراک:
                            </Typography>
                            <Chip
                                size="small"
                                color="secondary"
                                label={"۴,۰۰۰ پروژه"}
                            ></Chip>
                        </Stack>

                        <Typography color="secondary">
                            حرفه‌ای و به‌صرفه
                        </Typography>

                        <Typography
                            color="text.secondary"
                            sx={{ minHeight: "190px" }}
                        >
                            «رویان»، از روییدن، اشتراک رشد، حرکت و پویایی است
                            چون پروژه‌ها منتظر نمی‌مانند و باید بلافاصله دسترسی
                            داشته باشید تا رشد کنید. ما اطلاعات نمی‌فروشیم؛ ما
                            فرصت‌ها را زنده تحویل می‌دهیم. با اشتراک ویژه‌ی
                            «رویان»، پروژه‌ها بلافاصله پس از انتشار در اختیار
                            شما هستند — بدون تاخیر، کامل و جامع. علاوه بر تمامی
                            امکانات و ویژگی‌های اشتراک قبلی، در اشتراک «رویان»
                            خدمات دیگری مانند سرشماره‌ی خدماتی، شارژ رایگان،
                            کارگاه‌های آموزشی رایگان بیشتر با موضوعات گسترده‌تر
                            و ...، در دستان شما هستند تا راحت‌تر و سریع‌تر رشد
                            کنید. این اشتراک مناسب آنهایی است که نمی‌خواهند از
                            رقبا عقب بمانند. با این اشتراک همیشه یک قدم جلو
                            هستید.
                        </Typography>

                        <Stack gap={2}>
                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    متراژ زمین:
                                </Typography>
                                <Typography color="text.primary" sx={{fontWeight: 1000}}>
                                    تا ۶۰۰ متر
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    کاربری: مسکونی، مسکونی تجاری و
                                </Typography>
                                <Typography color="text.primary" sx={{fontWeight: 1000}}>
                                    اداری تجاری
                                </Typography>
                            </Stack>
                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    زمان دسترسی به پروژه‌ها: &nbsp;
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        بلافاصله پس از گردآوری و به‌روزرسانی
                                    </Typography>
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    بازدید هفتگی پروژه‌ها:
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        {" "}
                                        ۵۰۰ پروژه
                                    </Typography>
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    پروژه‌های درخواست خرید از سوی سازنده:
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        دارد
                                    </Typography>
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    {`شهرهای حومه: `}
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        ۲۰۰ - ۵۰
                                    </Typography>
                                    {` پروژه`}
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    پنل تبلیغات و پیامک: &nbsp;
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        ۱۵۰۰ شارژ رایگان یک ساله
                                    </Typography>
                                    &nbsp; (شارژ بیشتر باید جداگانه خریداری شود)
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    سرشماره‌ی خدماتی برای پنل پیامک: &nbsp;
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        ۱۵ روز رایگان یک ساله
                                    </Typography>
                                    &nbsp; (بیشتر باید جداگانه خریداری شود)
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    سازه‌افزار (تبلیغ در وب‌سایت تبلیغاتی صنعت
                                    ساختمان در صفحه‌ی یک گوگل): دارد
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    سی-آر-ام (فرآیندهای فروش): دارد
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    کارگاه‌های آموزشی:{" "}
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        ۴ بار (کارگاه/نفر) به مدت ۳۲ ساعت
                                    </Typography>
                                </Typography>
                            </Stack>
                        </Stack>

                        <span style={{ flex: 1 }}></span>

                        <Button
                            fullWidth={true}
                            variant="contained"
                            onClick={() =>
                                handleNavigateToSubscription([
                                    AccountSubscriptionType.STANDARD,
                                    AccountSubscriptionType.ENHANCED,
                                ])
                            }
                        >
                            مشاهده پروژه های این نوع اشتراک
                        </Button>
                    </Stack>
                </Grid>

                <Grid
                    item
                    xs={12}
                    md={6}
                    lg={4}
                >
                    <Stack
                        direction="column"
                        alignItems="center"
                        spacing={4}
                        sx={{
                            width: "100%",
                            height: "100%",
                            border: "1px solid",
                            borderColor: "divider",
                            backgroundColor: "background.paper",
                            p: 4,
                            borderRadius: "12px",
                        }}
                    >
                        <img
                            alt="taban"
                            width={75}
                            height={75}
                            src="images/subscriptions/taban.png"
                        />

                        <Stack
                            direction="row"
                            justifyContent="center"
                            gap={2}
                            sx={{
                                bgcolor: "#9848FF",
                                py: 1,
                                borderRadius: "12px",
                                width: "200px",
                                textAlign: "center",
                            }}
                        >
                            <Typography
                                sx={{ fontSize: "20px" }}
                                color="white"
                            >
                                تابان
                            </Typography>

                            {accountSubscriptionType ===
                                AccountSubscriptionType.ULTIMATE && (
                                <Chip
                                    color="secondary"
                                    label="اشتراک شما"
                                />
                            )}
                        </Stack>

                        <Stack
                            direction="row"
                            gap={1}
                            alignItems="center"
                        >
                            <Typography color="primary">
                                تعداد تقریبی پروژه‌‌ها:
                            </Typography>
                            <Chip
                                size="small"
                                color="primary"
                                label={"۱۷,۰۰۰ پروژه"}
                            ></Chip>
                        </Stack>

                        <Stack
                            direction="row"
                            gap={1}
                            alignItems="center"
                        >
                            <Typography color="primary">
                                پروژه‌های خاص این اشتراک:
                            </Typography>
                            <Chip
                                size="small"
                                color="secondary"
                                label={"۳,۰۰۰ پروژه"}
                            ></Chip>
                        </Stack>

                        <Typography color="secondary">
                            برگ برنده: پروژه‌های خاص و بیشتر
                        </Typography>

                        <Typography
                            color="text.secondary"
                            sx={{ minHeight: "190px" }}
                        >
                            پیشرو که باشید، «تابان» می‌شوید، یعنی می‌درخشید و با
                            کار و عملکردتان دیگران را هم روشن و نورانی می‌کنید.
                            هرآنچه که اشتراک‌های دیگر دارند که جای خود، آنچه
                            دیگران ندارند، اینجاست: پروژه‌های خاص و انحصاری تا
                            بازار را بسازید و برگ برنده داشته باشید. زمان فراتر
                            از طلاست و دسترسی به اطلاعات بیشتر، با کیفیت و خاص،
                            دارایی به ارزش الماس است. حالا اگر هردوی این‌ها را
                            داشته باشید، نه تنها بازار در دستان شماست، بلکه
                            می‌توانید بازار خودتان را بسازید. این یعنی با دردسر
                            کمتر، فروش بیشتر. با این اشتراک، برگ برنده در دستان
                            شماست، پس پیش بتازید و پرچم‌دار شوید.
                        </Typography>

                        <Stack gap={2}>
                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                   متراژ زمین:
                                </Typography>
                                <Typography color="text.primary" sx={{fontWeight: 1000}}>
                                    بدون محدودیت
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    کاربری: مسکونی، مسکونی تجاری و
                                </Typography>
                                <Typography color="text.primary" sx={{fontWeight: 1000}}>
                                    اداری تجاری
                                </Typography>
                            </Stack>
                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography
                                    color="text.primary"
                                    sx={{ fontWeight: "1000" }}
                                >
                                    تمامی ساختمان‌های در حال ساخت تهران شامل
                                    پروژه‌های بزرگ و خاص
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    زمان دسترسی به پروژه‌ها:
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        {" "}
                                        بلافاصله پس از گردآوری و به‌روزرسانی{" "}
                                    </Typography>
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    بازدید هفتگی پروژه‌ها:
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        {" "}
                                        ۵۰۰ پروژه
                                    </Typography>
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    پروژه‌های درخواست خرید از سوی سازنده:
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        {" "}
                                        دارد{" "}
                                    </Typography>
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    شهرهای حومه:
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        {" "}
                                        ۵۰۰ - ۱۰۰{" "}
                                    </Typography>{" "}
                                    پروژه
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    پنل تبلیغات و پیامک: &nbsp;
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        ۳۰۰۰ شارژ رایگان یک ساله
                                    </Typography>
                                    &nbsp; (شارژ بیشتر باید جداگانه خریداری شود)
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    سرشماره‌ی خدماتی برای پنل پیامک: &nbsp;
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        ۳۰ روز رایگان یک ساله
                                    </Typography>
                                    &nbsp; (بیشتر باید جداگانه خریداری شود)
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    سازه‌افزار (تبلیغ در وب‌سایت تبلیغاتی صنعت
                                    ساختمان در صفحه‌ی یک گوگل): دارد
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    سی-آر-ام (فرآیندهای فروش): دارد
                                </Typography>
                            </Stack>

                            <Stack
                                direction="row"
                                gap={1}
                            >
                                <Icon color="secondary">done</Icon>
                                <Typography color="text.secondary">
                                    کارگاه‌های آموزشی:{" "}
                                    <Typography
                                        component={"span"}
                                        color="text.primary"
                                        sx={{ fontWeight: "1000" }}
                                    >
                                        ۸ بار (کارگاه/نفر) به مدت ۶۴ ساعت
                                    </Typography>
                                </Typography>
                            </Stack>
                        </Stack>

                        <span style={{ flex: 1 }}></span>

                        <Button
                            fullWidth={true}
                            variant="contained"
                            onClick={() => handleNavigateToSubscription([])}
                        >
                            مشاهده پروژه های این نوع اشتراک
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
        </Container>
    );
}
